<template>
<div class="px-6 pb-6">
  <v-card class="rounded-lg px-6 py-6" elevation="0" style="border: 1px solid #e0e0e0;">
    <div class="d-flex align-center justify-space-between mb-6 flex-wrap">
      <div>
        <h2 class="text-h5 font-weight-bold grey--text text--darken-3 mb-1">
          Пресеты ролей
        </h2>
        <div class="text-body-2 grey--text">
          Готовые наборы компетенций под роли
        </div>
      </div>
      <v-btn
        color="#009E60"
        dark
        depressed
        class="text-capitalize mt-2 mt-sm-0 px-6"
        height="40"
        @click.prevent.stop="openPresetModal(null)"
      >
        <template v-slot:default="data">
          <div class="d-flex justify-space-between align-center">
            <v-icon size="16px">
              mdi-plus
            </v-icon>
            <div class="font-sm ">Новый пресет</div>
          </div>
        </template>
      </v-btn>
    </div>
    <v-row v-if="presetsRoles && presetsRoles.length">
      <v-col
        v-for="(preset, index) in presetsRoles"
        :key="preset.id != null ? preset.id : index"
        cols="12" sm="6" md="6"
      >
        <CardItem
          :data="preset"
          :type="'preset'"
          :action="true"
          :competencies="competencies"
          @edit="openPresetModal(preset.id)"
          @delete="deletePresetItem(preset)"
        />
      </v-col>
    </v-row>
    <!-- Empty -->
    <div v-else-if="!presetsRoles.length" class="d-flex flex-column align-center py-10">
      <v-icon size="48" color="grey lighten-2">mdi-folder-open-outline</v-icon>
      <p class="text-body-2 grey--text mt-3">Нет пресетов. Нажмите «Новый пресет».</p>
    </div>
    <v-row v-else>
      <v-col
        v-for="(preset, index) in 4"
        :key="index"
        cols="12" sm="6" md="4"
      >
        <CardItemSkeleton
          :data="preset"
          :type="'presets'"
          :action="true"
        />
      </v-col>
    </v-row>

  </v-card>
</div>

</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import CardItem from './CardItem.vue';
import CardItemSkeleton from './CardItemSkeleton.vue';

export default {
  name: 'PresetsRoles',
  components: { CardItemSkeleton, CardItem },
  computed: {
    ...mapGetters({
      presetsRoles: 'diagnostics/diagnotics/presetsRoles',
      competencies: 'diagnostics/diagnotics/libraryCompetencies'
    }),
  },
  methods: {
    ...mapMutations({
      SET_PRESET_SHOW_MODAL: 'diagnostics/diagnotics/SET_PRESET_SHOW_MODAL',
    }),
    ...mapActions({
      openEditPreset: 'diagnostics/diagnotics/openEditPreset',
      openCreatePreset: 'diagnostics/diagnotics/openCreatePreset',
      deletePreset: 'diagnostics/diagnotics/deletePreset',
    }),
    openPresetModal(id) {
      try {
        if (id) {
          this.openEditPreset(id);
        } else {
          this.openCreatePreset();
        }
      } catch (err) {
        this.$toast.error('Ошибка,попробуйте позже...', '', { position: 'topRight' });
      }
    },
    async deletePresetItem(preset) {
      await this.deletePreset(preset.id);
    }
  }
};
</script>

<style scoped lang="scss">

</style>
